import React from 'react'

/**
 * Renders text with a segment wrapped in <strong>
 *
 *   Example:
 *
 *   renderWithBoldSubstring( "Hello mate", 6, 5 ) // Hello <strong>mate<strong>
 *
 *
 * @param {*} text       - Whole text
 * @param {*} charIndex  - Character index where hilite begins
 * @param {*} length     - Number of chars to be shown bold
 */
const renderWithBoldSubstring = (text, charIndex, length) => {
  return (charIndex > -1)
    ? [
      text.substring(0, charIndex),
      <strong key='h'>{ text.substr(charIndex, length) }</strong>,
      text.substring(charIndex + length, text.length)
    ]
    : text
}

export default renderWithBoldSubstring
